module.exports = __webpack_public_path__ + "img/ball2_xn.162d59d7.png";